var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"mt-4"},[_c('b-row',[_c('b-col',{staticClass:"p-0",attrs:{"cols":"12","md":"3","lg":"2"}},[_c('EventMenu')],1),_c('b-col',{attrs:{"cols":"12","md":"9","lg":"10"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }